<template>
	<div id="wrapper">
		<div id="main">
			<Intro/>
			<Projects/>
			<Tools/>
			<Contacts/>
		</div>
	</div>
</template>
<script>
import Intro from './components/Intro.vue'
import Projects from './components/Projects.vue'
import Tools from './components/Tools.vue'
import Contacts from './components/Contacts.vue'

export default {
  name: 'Wrapper',
  components: {
    Intro,
    Projects,
    Tools,
    Contacts
  }
}
</script>